export const buildMarketingName = ({
  selectedNodes = [],
  currentNode,
}) =>
  [...selectedNodes.map(({name}) => name), currentNode]
    .filter(Boolean)
    .filter(name => name !== "")
    .join(":");
